import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

//Helper functions
import { getSettings, notifyError, notifySuccess } from '../../../settings/Helpers';

//API
import api from '../../../settings/AxiosSetup';

//3rd party
import * as Icon from 'react-bootstrap-icons';
import toast, { Toaster } from 'react-hot-toast';
import { Tooltip } from 'react-tooltip';
import 'moment/locale/nl';
import moment from 'moment';
import 'moment-timezone';
import Skeleton from 'react-loading-skeleton';
import DataTable from 'react-data-table-component';
import { Drawer, Timeline, Loader } from 'rsuite';
import { confirmAlert } from 'react-confirm-alert';

//Components
import SideNav from '../../../components/sidenav/sidenav';
import BottomNav from '../../../components/bottomnav/bottomnav';
import DashboardHeader from '../../../components/dashboard/header';

//Assets
import svzArtwork from '../../../assets/images/artwork-svz.svg';

//styles
import './voorraden.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-tooltip/dist/react-tooltip.css';
import 'rsuite/dist/rsuite-no-reset.min.css';


const Voorraden = () => {
    const navigate = useNavigate();
    const environment = process.env.REACT_APP_APP_URL;
    const loggedIn = localStorage.getItem('ingelogd');
    const medewerker = JSON.parse(localStorage.getItem('medewerker'));
    const [voorraden, setVoorraden] = useState([
        { naam: '', locatie: '', aantal: 0 }
    ]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const getVoorraden = async () => {
        try {
            const response = await api.get('/voorraden');
            if (response.data) {
                if (response.data.length > 0) {
                    setVoorraden(response.data);

                }
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const settings = getSettings();
        settings.then((result) => {
            if (result.onderhoudsmodus) {
                navigate('/onderhoud');
            }
        });
        if (loggedIn !== 'true') {
            navigate('/login');
        }
        getVoorraden();
    }, []);

    const handleChange = (index, field, value) => {
        const updated = [...voorraden];
        updated[index][field] = value;
        setVoorraden(updated);
    };

    const addRow = () => {
        setVoorraden([...voorraden, { naam: '', locatie: '', aantal: 0 }]);
    };

    const removeRow = (index) => {
        if (voorraden.length > 1) {
            const updated = voorraden.filter((_, i) => i !== index);
            setVoorraden(updated);
        } else {
            toast.error("Er moet minstens één regel zijn.");
        }
    };

    const saveVoorraden = async () => {
        // Verwijder regels die helemaal leeg zijn
        const gefilterdeVoorraden = voorraden.filter(item =>
            item.naam.trim() !== '' || item.locatie.trim() !== '' || item.aantal !== 0
        );
    
        // Check of er regels zijn met deels lege velden
        const ongeldigeRegels = gefilterdeVoorraden.filter(item =>
            item.naam.trim() === '' || item.locatie.trim() === '' || item.aantal === 0
        );
    
        if (ongeldigeRegels.length > 0) {
            toast.error('Alle regels moeten volledig ingevuld zijn (naam, locatie, aantal).');
            return;
        }
    
        setIsSaving(true);

        try {
            const response = await api.post('/voorraden/update', {
                data: gefilterdeVoorraden
            });
            if (response.data) {
                toast.success('Voorraden zijn opgeslagen');
                setVoorraden(response.data);
                setIsSaving(false);
            }
        } catch (error) {
            console.log(error);
            toast.error('Er ging iets mis bij het opslaan.');
        }
    };    

    return (
        <div id="main" className="dashboard">
            {medewerker && <SideNav page="/voorraden" />}
    
            <div className="dashboard-content">
                <DashboardHeader title="HR Voorraad" subtitle="" />
    
                <div className="voorraden">
                    {isLoading ? (
                        <>
                            <Skeleton height={40} width={'100%'} style={{marginBottom:20}} />
                            <Skeleton height={40} width={'100%'} style={{marginBottom:20}} />
                            <Skeleton height={40} width={'100%'} style={{marginBottom:20}} />
                        </>
                    ) : (
                        <>
                            <table className="voorraad-tabel" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'left' }}>Naam</th>
                                        <th style={{ textAlign: 'left' }}>Locatie</th>
                                        <th style={{ textAlign: 'left' }}>Aantal</th>
                                        <th style={{ textAlign: 'left' }}>Acties</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {voorraden.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ paddingTop: '5px' }}>
                                                <input
                                                    type="text"
                                                    value={item.naam}
                                                    onChange={(e) => handleChange(index, 'naam', e.target.value)}
                                                    className="voorraad-input"
                                                    disabled={isSaving}
                                                />
                                            </td>
                                            <td style={{ paddingTop: '5px' }}>
                                                <input
                                                    type="text"
                                                    value={item.locatie}
                                                    onChange={(e) => handleChange(index, 'locatie', e.target.value)}
                                                    className="voorraad-input"
                                                    disabled={isSaving}
                                                />
                                            </td>
                                            <td style={{ paddingTop: '5px' }}>
                                                <input
                                                    type="text"
                                                    value={item.aantal}
                                                    onChange={(e) => handleChange(index, 'aantal', e.target.value)}
                                                    className="voorraad-input"
                                                    disabled={isSaving}
                                                />
                                            </td>
                                            <td style={{ padding: '15px' }}>
                                                <Icon.DashCircleFill onClick={() => removeRow(index)} className="remove-row" color={'#e10514'} size={24} />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
    
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button onClick={addRow} className="button red">
                                    <Icon.Plus /> Regel toevoegen
                                </button>
                                <button onClick={saveVoorraden} className="button green" disabled={isSaving}>
                                    Opslaan
                                </button>
                            </div>
                        </>
                    )}
                </div>
    
                <Toaster />
            </div>
    
            {medewerker && <BottomNav page="/voorraden" />}
            <img src={svzArtwork} className="artwork" />
        </div>
    );
    
};

export default Voorraden;